import BaseModel from './BaseModel';
import { asyncFn } from './utils';

class GlobalModel extends BaseModel {
  constructor(data = {}) {
    super(data);

    this.districtModel = {
      request: this.buildActionName('request', 'district'),
      response: this.buildActionName('response', 'district'),
      error: this.buildActionName('error', 'district'),
    };

    this.updateDistrictModel = {
      request: this.buildActionName('request', 'district', 'update'),
      response: this.buildActionName('response', 'district', 'update'),
      error: this.buildActionName('error', 'district', 'update'),
    };

    this.eventModel = {
      request: this.buildActionName('request', 'event'),
      response: this.buildActionName('response', 'event'),
      error: this.buildActionName('error', 'event'),
    };

    this.initialState = {
      collapsed: false,
      notices: [],
      categories: [],
      districts: [],
      events: [],
      indexedCategories: {},
      fetchingNotices: false,
      isGlobalLoading: false,
    };
    this.persist = true;
  }

  loadDistrict = () => asyncFn({
    url: '/rest/store/district_list', method: 'POST', model: this.districtModel,
  })

  loadEvent = () => asyncFn({
    url: '/rest/app/select_event', method: 'POST', model: this.eventModel,
  })

  updateDistrict = districts => asyncFn({
    body: { districts: districts.map(entry => parseInt(entry, 10)) }, url: '/rest/store/update_district', method: 'POST', model: this.updateDistrictModel,
  })

  onCollapse = keys => (dispatch) => {
    dispatch({
      type: 'onCollapse',
      keys,
    });
  }

  reducer = (state = this.initialState, action) => {
    switch (action.type) {
      case this.districtModel.response:
        return {
          ...state,
          isLoading: false,
          isLogged: true,
          districts: action.payload,
        };
      case this.districtModel.request:
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      case this.districtModel.error:
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      case this.updateDistrictModel.request:
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      case this.updateDistrictModel.error:
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      case this.updateDistrictModel.response:
        return {
          ...state,
          isLoading: false,
        };
      case this.eventModel.request:
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      case this.eventModel.error:
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      case this.eventModel.response:
        return {
          ...state,
          isLoading: true,
          events: action.payload,
        };
      default:
        return state;
    }
  }
}

export default GlobalModel;



// WEBPACK FOOTER //
// ./src/models/GlobalModel.js